import { render, staticRenderFns } from "./ConfirmationByPhoneSection.vue?vue&type=template&id=418204e8&"
import script from "./ConfirmationByPhoneSection.vue?vue&type=script&lang=js&"
export * from "./ConfirmationByPhoneSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports